export default __webpack_public_path__ + "static/media/Logo.a494a924.png";